export default __webpack_public_path__ + "static/media/kokoss.c7657eeb.png";